import UserActions from "../NipTypes";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/apiNip";
import Storage from "../../utils/storage";

// GET NIP DOCUMENTATION KIT
export const getNipKitStart = () => ({
    type: UserActions.GET_NIP_KIT_START,
});

export const getNipKitSuccess = (payload) => ({
    type: UserActions.GET_NIP_KIT_SUCCESS,
    payload,
});

export const getNipKitFailure = (payload) => ({
    type: UserActions.GET_NIP_KIT_FAILURE,
    payload,
});

// GET NIP DOCUMENTATION KIT
export const downloadNipKitStart = () => ({
    type: UserActions.DOWNLOAD_NIP_KIT_START,
});

export const downloadNipKitSuccess = (payload) => ({
    type: UserActions.DOWNLOAD_NIP_KIT_SUCCESS,
    payload,
});

export const downloadNipKitFailure = (payload) => ({
    type: UserActions.DOWNLOAD_NIP_KIT_FAILURE,
    payload,
});

// GET ALL NIP APPLICATIONS
export const getAllNipApplicationsStart = () => ({
    type: UserActions.GET_ALL_NIP_APPLICATIONS_START,
});

export const getAllNipApplicationsSuccess = (payload) => ({
    type: UserActions.GET_ALL_NIP_APPLICATIONS_SUCCESS,
    payload,
});

export const getAllNipApplicationsFailure = (payload) => ({
    type: UserActions.GET_ALL_NIP_APPLICATIONS_FAILURE,
    payload,
});

// GET SINGLE NIP APPLICATIONS
export const getSingleNipApplicationStart = () => ({
    type: UserActions.GET_SINGLE_NIP_APPLICATION_START,
});

export const getSingleNipApplicationSuccess = (payload) => ({
    type: UserActions.GET_SINGLE_NIP_APPLICATION_SUCCESS,
    payload,
});

export const getSingleNipApplicationFailure = (payload) => ({
    type: UserActions.GET_SINGLE_NIP_APPLICATION_FAILURE,
    payload,
});

// SUBMIT NIP APPLICATION
export const submitNipApplicationStart = () => ({
    type: UserActions.SUBMIT_NIP_APPLICATION_START,
});

export const submitNipApplicationSuccess = (payload) => ({
    type: UserActions.SUBMIT_NIP_APPLICATION_SUCCESS,
    payload,
});

export const submitNipApplicationFailure = (payload) => ({
    type: UserActions.SUBMIT_NIP_APPLICATION_FAILURE,
    payload,
});

// SUBMIT REQUEST FOR PERMIT
export const sendRequestForPermitStart = () => ({
    type: UserActions.SUBMIT_REQUEST_FOR_PERMIT_START,
});

export const sendRequestForPermitSuccess = (payload) => ({
    type: UserActions.SUBMIT_REQUEST_FOR_PERMIT_SUCCESS,
    payload,
});

export const sendRequestForPermitFailure = (payload) => ({
    type: UserActions.SUBMIT_REQUEST_FOR_PERMIT_FAILURE,
    payload,
});

// SUBMIT REQUEST FORM
export const submitRequestFormStart = () => ({
    type: UserActions.SUBMIT_REQUEST_FORM_START,
});

export const submitRequestFormSuccess = (payload) => ({
    type: UserActions.SUBMIT_REQUEST_FORM_SUCCESS,
    payload,
});

export const submitRequestFormFailure = (payload) => ({
    type: UserActions.SUBMIT_REQUEST_FORM_FAILURE,
    payload,
});

// UPLOAD KEY
export const uploadKeyStart = () => ({
    type: UserActions.UPLOAD_KEY_START,
});

export const uploadKeySuccess = (payload) => ({
    type: UserActions.UPLOAD_KEY_SUCCESS,
    payload,
});

export const uploadKeyFailure = (payload) => ({
    type: UserActions.UPLOAD_KEY_FAILURE,
    payload,
});

// CLEAR STATE
export const clearNipState = () => ({
    type: UserActions.CLEAR_NIP_STATE
})

export const getNipKit = () => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(getNipKitStart());
    API.get("onboarding/kit").then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(getNipKitSuccess(data && data.data));
        } else {
            dispatch(getNipKitFailure(data));
        }
    });
};

export const downloadNipKit = (type) => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(downloadNipKitStart());
    API.get(`/onboarding/download?type=${type}`).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(downloadNipKitSuccess(data));
            window.open(`${process.env.REACT_APP_API_NIP}/onboarding/download?type=${type}`, "_parent")
        } else {
            dispatch(downloadNipKitFailure(data));
        }
    });
};

export const getAllNipApplications = () => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(getAllNipApplicationsStart());
    API.get("onboarding/application").then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(getAllNipApplicationsSuccess(data && data.data));
        } else {
            dispatch(getAllNipApplicationsFailure(data));
        }
    });
};

export const getSingleNipApplication = (id) => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(getSingleNipApplicationStart());
    API.get(`onboarding/application/${id}`).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(getSingleNipApplicationSuccess(data && data.data));
        } else {
            dispatch(getSingleNipApplicationFailure(data));
        }
    });
};

export const submitNipApplication = (payload, type) => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(submitNipApplicationStart());
    API.post(
        type === "upload" ?
            "onboarding/application" :
            "onboarding/application/update-doc",
        payload
    ).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(submitNipApplicationSuccess(data.data));
        } else {
            dispatch(submitNipApplicationFailure(data));
        }
    });
};

export const sendRequestForPermit = (payload) => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(sendRequestForPermitStart());
    API.post("onboarding/send-network-manager-mail", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(sendRequestForPermitSuccess(data.data));
        } else {
            dispatch(sendRequestForPermitFailure(data));
        }
    });
};

export const submitRequestForm = (payload, type) => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(submitRequestFormStart());
    API.post(
        type === "upload" ?
            "onboarding/application/ip-permit-form" :
            "onboarding/application/update-ip-permit",
        payload
    ).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(submitRequestFormSuccess(data.data));
        } else {
            dispatch(submitRequestFormFailure(data));
        }
    });
};

export const uploadKey = (payload) => async (dispatch) => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"));

    dispatch(uploadKeyStart());
    API.post("onboarding/upload-public-key", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(uploadKeySuccess(data.data));
        } else {
            dispatch(uploadKeyFailure(data));
        }
    });
};